(function() {
    'use strict';

    angular.module("product")
        .controller('ProductOptionPricesByQuantityUpdate', ProductOptionPricesByQuantityUpdate);

    ProductOptionPricesByQuantityUpdate.$inject = ['currentOption', 'product', '$uibModalInstance', 'productOptionPricesDataSrvc', 'lodashService', 'productoptionpricePermissionsConst'];

    function ProductOptionPricesByQuantityUpdate(currentOption, product, $uibModalInstance, productOptionPricesDataSrvc, lodashService, productoptionpricePermissionsConst) {
        var self = this;

        self.quantityRows = product.quantities.map(function(item) {
            var price = lodashService.find(product.option_prices, function(price) {
                return price.product === product.pk &&
                    price.product_option === currentOption.option &&
                    price.product_quantity === item.pk;
            });
            return {
                quantity: item.quantity,
                price: price ? parseFloat(price.price) : 0,
                pk: item.pk
            };
        });
        self.quantityCols = [{
            title: 'Nakład',
            value: 'quantity',
            type: 'number',
            isEditable: false
        }, {
            title: 'Cena',
            value: 'price',
            type: 'number',
            required: true,
            minValue: 0,
            isEditable: true
        }];
        self.modelPermissions = productoptionpricePermissionsConst;

        self.ok = ok;
        self.onQuantityEdit = onQuantityEdit;

        function ok() {
            $uibModalInstance.close();
        }

        function onQuantityEdit(row) {
            var callback = productOptionPricesDataSrvc.priceDetail({}, {
                product_option: currentOption.option,
                product_quantity: row.pk,
                product: product.pk,
                price: row.price
            });

            callback.$promise.then(
                function(response) {
                    product.option_prices = response;
                }
            );

            return callback;
        }
    }
})();
